import ServiceList from "./ServiceList";

class InitThirdAppService {
  static List: any;
  static group: any;
  static init() {
    this.List = this.List ? this.List : new ServiceList("thirdApp.db", "lists");
  }
  static clearServiceAll() {
    this.List?.destory();
    this.List = null;
  }
  static GetListService() {
    return this.List || new ServiceList("thirdApp.db", "lists");
  }
  static setGroup(group: any) {
    this.group = group;
  }
}

export default InitThirdAppService;
